import type { ProjectSummary } from "@/types/workspace"

/** Human label for the project's storyboard image generation model. */
export function storyboardModelLabel(p: ProjectSummary): string {
  return p.storyboard_generation_model_label?.trim() || effectiveStoryboardImageProvider(p) || "—"
}

/** Human label for the project's video generation model. */
export function videoModelLabel(p: ProjectSummary): string {
  return p.video_generation_model_label?.trim() || effectiveVideoGenerationProvider(p) || "—"
}

/** Current storyboard engine (Platform Config inherit, not stale legacy kling column). */
export function effectiveStoryboardImageProvider(p: {
  effective_storyboard_image_provider?: string | null
  storyboard_image_provider?: string | null
}): string {
  return (p.effective_storyboard_image_provider || p.storyboard_image_provider || "kling").toString()
}

/** Current video engine for capability flags (Platform Config inherit, not stale legacy column). */
export function effectiveVideoGenerationProvider(p: {
  effective_video_generation_provider?: string | null
  video_generation_provider?: string | null
}): string {
  return (p.effective_video_generation_provider || p.video_generation_provider || "kling").toString()
}

/** Human label for the project's storyboard correction model. */
export function storyboardCorrectionModelLabel(p: ProjectSummary): string {
  return p.storyboard_correction_model_label?.trim() || "—"
}

/** Human label for the project's video correction model. */
export function videoCorrectionModelLabel(p: ProjectSummary): string {
  return p.video_correction_model_label?.trim() || "—"
}
